export default {
  name: "Material Terms of Employment Profile",
  sections: [
    {
      name: "Material Terms of Employment Profile",
      fields: [
        {
          machine_name: "new_profile_material_terms_section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
            "Other Material Terms and Conditions",
          ],
          dynamicUpdates: [
            {
              set: "new_profile_material_terms_summary",
              to: "Job Duties",
              if: "Job Duties",
            },
            {
              set: "new_profile_material_terms_summary",
              to: "Overtime Pay",
              if: "Overtime Pay",
            },
            {
              set: "new_profile_material_terms_summary",
              to: "Minimum Productivity/Performance Standards",
              if: "Minimum Productivity/Performance Standards",
            },
            {
              set: "new_profile_material_terms_summary",
              to: "Job Qualifications/Requirements",
              if: "Job Qualifications/Requirements",
            },
            {
              set: "new_profile_material_terms_summary",
              to: "Provision of Meals",
              if: "Provision of Meals",
            },
            {
              set: "new_profile_material_terms_summary",
              to: "Daily Transportation",
              if: "Daily Transportation",
            },
            {
              set: "new_profile_material_terms_summary",
              to: "Inbound/Outbound Transportation",
              if: "Inbound/Outbound Transportation",
            },
            {
              set: "new_profile_material_terms_summary",
              to: "Deductions from Pay",
              if: "Deductions from Pay",
            },
            {
              set: "new_profile_material_terms_summary",
              to: null,
              if: "Other Material Terms and Conditions",
            },
          ],
          validate: ["required"],
        },
        {
          machine_name: "new_profile_material_terms_summary",
          label: "Summary of Material Term or Condition",
          widget: "text",
          disabled: true,
          isVisible: {
            when: "new_profile_material_terms_section_number",
            is: ["Other Material Terms and Conditions", "- Select -"],
            operator: "!==",
          },
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "new_profile_material_terms_summary",
          label: "Summary of Material Term or Condition",
          isVisible: {
            when: "new_profile_material_terms_section_number",
            is: "Other Material Terms and Conditions",
          },
          widget: "text",
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "new_profile_material_terms_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 5000,
          validate: [
            "required",
            {
              minLength: 5,
            },
          ],
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_material_terms_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          maxLength: 50,
          validate: ["required"],
          tooltip:
            "Enter a unique name that will allow you to identify this profile",
        },
      ],
    },
  ],
};
